import {Component, Input, OnInit, OnChanges, SimpleChanges} from '@angular/core';

@Component({
  selector: 'app-loading-indicator',
  templateUrl: './loading-indicator.component.html',
  styleUrls: ['./loading-indicator.component.scss']
})
export class LoadingIndicatorComponent implements OnChanges {

  @Input() loading: boolean;
  @Input() receiveOrder: boolean | null;

  value = 0;

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.receiveOrder && this.receiveOrder === true) {
      const interval = setInterval(() => {
        this.value = this.value + Math.floor(Math.random() * 10) + 1;
        if (this.value >= 100) {
          this.value = 100;
          clearInterval(interval);
        }
      }, 2000);
    }
  }

}
